<script lang="ts">
  import { MediaQuery } from 'svelte/reactivity';
  import CubeGridSimple from '../lib/rubiks/CubeGridSimple.svelte';

  // Tiny screens can't fit three cubes + tickers side-by-side — show only
  // the deepest scramble (3 steps). Tablets shrink ticker + cube so the
  // three-cube row still fits.
  const isTiny = new MediaQuery('max-width: 600px');
  const isMedium = new MediaQuery('max-width: 900px');

  const depths = $derived(isTiny.current ? [3] : [1, 2, 3]);
  const tickerWidth = $derived(isTiny.current ? 260 : isMedium.current ? 220 : 280);
  const cubeSize = $derived(isTiny.current ? 40 : isMedium.current ? 34 : 40);
</script>

<section id="rubiks-cliff" class="rubiks-cliff">
  {#key depths.join(',') + ':' + tickerWidth}
    <CubeGridSimple {depths} {tickerWidth} {cubeSize} />
  {/key}
</section>

<style>
  .rubiks-cliff {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    width: 100%;
    max-width: 880px;
    min-height: 587px;
    margin: 0 auto var(--space-2xl);
  }
  @media (max-width: 600px) {
    .rubiks-cliff {
      min-height: 320px;
    }
  }
</style>
